import { Radios } from 'nhsuk-react-components';
import useFetchTeamDetails from '../../queries/fetch/fetchTeamDetails';

interface TeamRadioItemProps {
  teamId: string;
}

function TeamRadioItem({ teamId }: TeamRadioItemProps) {
  const teamDetails = useFetchTeamDetails({ teamId });

  return (
    <Radios.Item key={teamId} value={teamId}>
      {teamDetails.data?.team?.TEAM_NAME ?? teamId}
    </Radios.Item>
  );
}

export default TeamRadioItem;
